import { Badge, Stack, Typography } from '@mui/material'
import { useContext, useState } from 'react'

import useInspectionEntriesByStatus from '../../hooks/useInspectionEntriesByStatus/useInspectionEntriesByStatus'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import { SingleInspectionContext } from '../../providers/SingleInspectionProvider/SingleInspectionProvider'
import { EntryInfoStatusEnum } from '../../sdk'
import { CenteredLoading } from '../CenteredLoading/CenteredLoading'
import { EditSingleInspectionEntryDialog } from '../Estimates/InspectionDrawer/EditSingleInspectionEntryDialog'
import {
  ElevatedTab,
  ElevatedTabPanel,
  ElevatedTabs
} from '../SharedUI/ElevatedTab'
import SingleEntryUI from './SingleEntryUI'

const EntriesByStatusListContainer = () => {
  const { transformedServiceItems } = useContext(RepairOrderContext)

  const [statusIndex, setStatusIndex] = useState<number>(0)
  const { inspectionExpanded, associations, cannedJobsExpanded } = useContext(
    SingleInspectionContext
  )
  const { entriesByStatus } = useInspectionEntriesByStatus(
    inspectionExpanded,
    cannedJobsExpanded
  )
  const [editDialog, setEditDialog] = useState('')

  if (!entriesByStatus) return <CenteredLoading />
  if (entriesByStatus.length === 0) {
    return <></>
  }

  return (
    <>
      {editDialog && (
        <EditSingleInspectionEntryDialog
          id={editDialog}
          {...{ setEditDialog }}
        />
      )}

      <ElevatedTabs value={statusIndex} onChange={(e, v) => setStatusIndex(v)}>
        {entriesByStatus.map((status, index) => (
          <ElevatedTab
            label={
              <>
                <Typography
                  variant="subtitle1"
                  sx={{
                    flex: '1 1 auto',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                  {status.info!.title}
                </Typography>
                {status.info!.title !== EntryInfoStatusEnum.Passed && (
                  <Badge
                    badgeContent={
                      status.entries.filter((e) => !e.info!.addressed).length
                    }
                    sx={{
                      flex: '0 0 auto',
                      m: 1,
                      mr:
                        status.entries
                          .filter((e) => !e.info!.addressed)
                          .length.toString().length + 1,
                      px: '3px'
                    }}
                    color="warning"
                  />
                )}
              </>
            }
            key={status.id!}
            value={index}
          />
        ))}
      </ElevatedTabs>

      <ElevatedTabPanel>
        {entriesByStatus.map(
          (status, index) =>
            index === statusIndex && (
              <Stack spacing={1} key={status.id!}>
                {status.entries
                  .filter((entry) => entry.prompts.length > 0)
                  .slice()
                  .sort(
                    (a, b) =>
                      (a.info?.addressed ? 1 : 0) - (b.info?.addressed ? 1 : 0)
                  )
                  .map((entry) => (
                    <SingleEntryUI
                      key={entry.id}
                      {...{
                        entry,
                        services: transformedServiceItems,
                        associations,
                        setEditDialog
                      }}
                    />
                  ))}
              </Stack>
            )
        )}
      </ElevatedTabPanel>
    </>
  )
}

export default EntriesByStatusListContainer
